let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("z47FH"), load("6qplU"), load("lnKog")]).then(() => parcelRequire('2mcHd'));